import { render, staticRenderFns } from "./exbupload.vue?vue&type=template&id=6e910a8f&scoped=true"
import script from "./exbupload.vue?vue&type=script&lang=js"
export * from "./exbupload.vue?vue&type=script&lang=js"
import style0 from "./exbupload.vue?vue&type=style&index=0&id=6e910a8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e910a8f",
  null
  
)

export default component.exports